import { Dialog } from '@mui/material';
import EmojiPicker from 'emoji-picker-react';
import React from 'react';
import useEmojiDialogStore from './emojiDialog.store';

function EmojiPickerDialog() {
  const isOpen = useEmojiDialogStore((state) => state.open);
  const setSelectedEmoji = useEmojiDialogStore(
    (state) => state.setSelectedEmoji
  );
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setSelectedEmoji(null);
      }}>
      <EmojiPicker
        onEmojiClick={(x) => {
          setSelectedEmoji(x.emoji);
        }}
      />
    </Dialog>
  );
}

export default EmojiPickerDialog;
